import React from 'react';
import './Profile.css';

const Profile = () => {
      const userData = JSON.parse(sessionStorage.getItem("userDetails"));
      return (
        <div className="profile-wrapper">
          <div className="profile-container">
            <div className="profile-left">
              <img
                src={userData?.profileImage || 'https://via.placeholder.com/200'}
                alt="Profile"
                className="profile-image"
              />
              <div className="profile-role">{userData?.role.roleName}</div>
            </div>
            <div className="profile-right">
              <h2 className="profile-name">{userData?.firstName + ' ' + userData?.lastName || 'John Doe'}</h2>
              <table className="profile-table">
                <tbody>
                  <tr>
                    <td className="left-align"><strong>Email:</strong></td>
                    <td>{userData?.email || 'johndoe@example.com'}</td>
                  </tr>
                  <tr>
                    <td className="left-align"><strong>ID:</strong></td>
                    <td>{userData?.id || 'EMP123456'}</td>
                  </tr>
                  <tr>
                    <td className="left-align"><strong>Contact:</strong></td>
                    <td>{userData.countryCode + userData?.phoneNumber || '+1234567890'}</td>
                  </tr>
                  {/* <tr>
                    <td className="left-align"><strong>Department:</strong></td>
                    <td>{userData?.department || 'Engineering'}</td>
                  </tr> */}
                  <tr>
                    <td className="left-align"><strong>Role:</strong></td>
                    <td>{userData?.role.roleName || 'Software Engineer'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      );
};

export default Profile;
